module.exports = "let menuItems = [\n   { payload: '1', text: 'Never' },\n   { payload: '2', text: 'Every Night' },\n   { payload: '3', text: 'Weeknights' },\n   { payload: '4', text: 'Weekends' },\n   { payload: '5', text: 'Weekly' },\n];\n<DropDownMenu menuItems={menuItems} />\n\nlet menuItemsWithLabel = [\n  { payload: '1', text: 'Morning', period: '5 am - 12 pm' },\n  { payload: '2', text: 'Afternoon', period: '12 pm - 5 pm' },\n  { payload: '3', text: 'Evening', period: '5 pm to 9 pm' },\n  { payload: '4', text: 'Night', period: '9 pm to 4 am' },\n];\n<DropDownMenu menuItems={menuItemsWithLabel} labelMember=\"period\" />\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/raw-code/drop-down-menu-code.txt
 ** module id = 798
 ** module chunks = 0
 **/